/**
 * ThemeToggle — botão icon-only que alterna dark/light.
 *
 * Hook `useTheme` cuida da persistência. Ícone reflete o que vai virar
 * ao clicar (sol no dark, lua no light) — convenção macOS/Vercel.
 */

import { Moon, Sun } from "lucide-react";

import { useTheme } from "@/hooks/useTheme";
import { cn } from "@/lib/utils";

export interface ThemeToggleProps {
  className?: string;
}

export function ThemeToggle({ className }: ThemeToggleProps) {
  const { theme, toggle } = useTheme();
  const isDark = theme === "dark";
  const Icon = isDark ? Sun : Moon;
  const label = isDark ? "Mudar para tema claro" : "Mudar para tema escuro";

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={label}
      title={label}
      className={cn(
        "inline-flex h-9 w-9 items-center justify-center rounded-md border border-[var(--color-border)]",
        "bg-transparent text-[var(--color-foreground)]",
        "transition-colors hover:bg-[var(--color-muted-tint)]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-ring)]",
        className,
      )}
    >
      <Icon className="h-4 w-4" aria-hidden="true" />
    </button>
  );
}
